// src/api/apiCategories.js
import axios from "../utils/axios";

// Get Categories (with pagination & filters)
export const getAllCategories = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("categories", { params });
    return data;
};

// Get Categories Tree
export const getCategoriesTree = async () => {
    const { data } = await axios.get("categories/tree");
    return data;
};

// Get Categories for Select Dropdown
export const getCategoriesForSelect = async () => {
    const { data } = await axios.get("categories/for-select");
    return data;
};

// Get Single Category
export const getCategory = async (id) => {
    if (!id) return null;
    const { data } = await axios.get(`categories/${id}`);
    return data;
};

// Create Category
export const createCategory = async (req) => {
    try {
        const { data } = await axios.post("categories", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createCategory error:", error);
        throw error;
    }
};

// Update Category
export const updateCategory = async (req, id) => {
    try {
        const { data } = await axios.put(`categories/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateCategory error:", error);
        throw error;
    }
};

// Soft Delete Category
export const deleteCategory = async (id) => {
    try {
        const { data } = await axios.delete(`categories/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteCategory error:", error);
        throw error;
    }
};

// Mass Soft Delete Categories
export const deleteAllCategories = async (req = []) => {
    try {
        const { data } = await axios.delete("categories/mass-destroy", {
            data: req,
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteAllCategories error:", error);
        throw error;
    }
};

// Force Delete Category
export const forceDeleteCategory = async (id) => {
    try {
        const { data } = await axios.delete(`categories/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteCategory error:", error);
        throw error;
    }
};

// Mass Force Delete Categories
export const forceDeleteAllCategories = async (ids = []) => {
    try {
        const { data } = await axios.delete("categories/mass-force-delete", {
            data: ids,
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteAllCategories error:", error);
        throw error;
    }
};

// Restore Category
export const restoreCategory = async (id) => {
    try {
        const { data } = await axios.post(`categories/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreCategory error:", error);
        throw error;
    }
};

// Mass Restore Categories
export const restoreAllCategories = async (req = []) => {
    try {
        const { data } = await axios.post("categories/mass-restore", { ...req }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAllCategories error:", error);
        throw error;
    }
};
